import React from 'react';
import {Container, ExternalLink, Row, WhiteTypography} from './FooterSharedStyles';

const NativeAppLinks = () => {
  return (
    <Container>
      <WhiteTypography variant='subheading2' component='span'>
        App herunterladen
      </WhiteTypography>
      <Row>
        <ExternalLink href='https://apps.apple.com/us/app/id942371609' target='_blank'>
          <img
            loading='lazy'
            height={40}
            width={120}
            alt='Lade die FuPa-App im App Store herunter'
            src='/badge/app-store-badge.svg'
          />
        </ExternalLink>
        <ExternalLink href='https://play.google.com/store/apps/details?id=prepublic.fupa' target='_blank'>
          <img
            loading='lazy'
            height={40}
            width={134}
            alt='Lade die FuPa-App im Google Play Store herunter'
            src='/badge/google-play-badge.svg'
          />
        </ExternalLink>
      </Row>
    </Container>
  );
};

export default NativeAppLinks;
